import { integrationLinksList } from "@/app/Settings/Settings/GraphQL/integrationLinksQueries";
import { useGqlMutation, useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { CellContext } from "@/lib/Components/DataTable/types";
import { useIntegrationRecord } from "@/app/Settings/Settings/Hooks/useIntegrationRecord";
import { ModelType } from "@/gql/graphql";
import { SupplierInsuranceOptionListItem } from "@/app/Suppliers/GraphQL/supplierInsuranceOptionListQuery";
import { Select } from "@/components/catalyst/select";
import { useState } from "react";
import { upsertIntegrationLink } from "@/app/Settings/Settings/GraphQL/integrationLinkMutations";

export function JucyInsuranceOptionCodeCell({
  row,
}: CellContext<SupplierInsuranceOptionListItem, any>) {
  const jucyIntegration = useIntegrationRecord();
  const { mutateAsync } = useGqlMutation(upsertIntegrationLink, {
    onSuccess: () => {
      return;
    },
  });

  const integrationLinks = useGqlQuery(integrationLinksList, {
    integration_id: jucyIntegration.id,
  });

  const integrationLink = integrationLinks.data?.integrationLinks.data.find(
    (item) => {
      return (
        item.object_type === ModelType.SupplierInsuranceOption &&
        item.object_id === row.original.id
      );
    },
  );

  const [externalId, setExternalId] = useState<string>(
    integrationLink?.external_id ?? "",
  );

  return (
    <Select
      value={externalId}
      onChange={async (e) => {
        setExternalId(e.target.value);
        await mutateAsync({
          id: integrationLink?.id,
          input: {
            external_id: e.target.value,
            object: {
              connect: {
                id: row.original.id,
                type: ModelType.SupplierInsuranceOption,
              },
            },
            integration: {
              connect: jucyIntegration.id,
            },
          },
        });
      }}
    >
      <option value="" disabled>
        Select an option
      </option>
      <option value="rtcm">Risk Taker - $5000 Excess/Bond (RTCM)</option>
      <option value="stcm">Stress Free (STCM)</option>
      <option value="spcm">Stress Free Plus (SPCM)</option>
    </Select>
  );
}
